import { Component, Inject, Output, EventEmitter } from '@angular/core';

import {
  BASE_PURCHASE_SERVICE,
  BasePurchaseService,
} from '../../services/base-purchase.service';
import { CreditCardService } from '../../services/credit-card.service';

@Component({
  selector: 'checkout-success',
  templateUrl: './checkout-success.component.html',
  styleUrls: ['./checkout-success.component.scss'],
  standalone: false,
})
export class CheckoutSuccessComponent {
  purchase = this.purchaseService.purchase;
  paymentMethods = this.creditCardService.paymentMethods;

  get purchasedMultiple(): boolean {
    return (
      this.purchaseService.purchase.volumePlan?.licenses > 0 &&
      this.purchaseService.purchase.unlimitedPlan?.licenses > 0
    );
  }

  get hasAddOnPurchase(): boolean {
    return !!this.purchaseService.purchase.addOnPlan?.name;
  }

  @Output() closeEvent: EventEmitter<any> = new EventEmitter();

  constructor(
    @Inject(BASE_PURCHASE_SERVICE)
    private purchaseService: BasePurchaseService,
    private creditCardService: CreditCardService,
  ) {}
}
